import React, { PropsWithChildren } from 'react';
import { MediaPlayerError } from '@yi/core';

import { isMediaId } from '~/src/common/media';
import { nr } from '~/src/common/newRelic';

import { FullscreenForSmallDevices } from './FullscreenForSmallDevices';
import {
  AdjustVolumeByClick,
  BrightcovePlayerStylesWrapper,
  HideVolumeButtonOnMobile,
  PlayerLoader,
  VolumeHotkeys,
} from './MediaPlayerBase';
import { MediaPlayerProvider, useMediaPlayer } from './MediaPlayerProvider';
import { ReportPlaybackError } from './ReportPlaybackError';

const Player: React.FC<PropsWithChildren> = ({ children }) => {
  const { player } = useMediaPlayer();

  // syncronize react lifecycle and videojs state
  const isPlayerReady = player !== null;

  return (
    <BrightcovePlayerStylesWrapper ready={isPlayerReady} showPosterOnEnd>
      <PlayerLoader>
        <VolumeHotkeys />
        <HideVolumeButtonOnMobile />
        <AdjustVolumeByClick />
        <FullscreenForSmallDevices />
        {children}
      </PlayerLoader>
    </BrightcovePlayerStylesWrapper>
  );
};

type Props = { mediaId: string };

export const EmbeddedPlayer: React.FC<PropsWithChildren<Props>> = ({ children, mediaId }) => {
  if (!isMediaId(mediaId)) {
    nr.noticeError(new MediaPlayerError('invalid media id'), { mediaId });
    return null;
  }

  return (
    <MediaPlayerProvider mediaId={mediaId}>
      <Player>{children}</Player>
      <ReportPlaybackError mediaId={mediaId} />
    </MediaPlayerProvider>
  );
};
